module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"statusFilterTitle":"Rolle","infoBoxTitle":"Rolle","infoBoxText":"Archivierte Liegenschaften werden standardmässig nicht geladen. Wählen Sie diese hier aus, um sie anzuzeigen.","types":{"PLANNER":"Planer","REPORTER":"Reporter","ARCHIVED":"Archiviert"}}}')
  delete Component.options._Ctor
}
